//benefit accordion
function benefitAccordion() {
  const benefitTrigger = document.getElementsByClassName('js-p-accordion-with-image');
  const offTriggerCourseName = document.getElementsByClassName('p-accordion-with-image__title-area');

  for (let i = 0; i < benefitTrigger.length; i++) {
    benefitTrigger[i].addEventListener('click', function () {
      if (this.classList.contains('is-child-open') === false) {
        this.classList.add('is-child-open');
        let targets = benefitTrigger[i].querySelectorAll('.js-benefit-target');
        targets.forEach((value, index) => {
          value.classList.add('is-dropdown-open');
          value.style.height = value.scrollHeight + 'px';
        });
      }
    });
  }

  for (let i = 0; i < offTriggerCourseName.length; i++) {
    offTriggerCourseName[i].addEventListener('click', function (e) {
      if (this.closest('.js-p-accordion-with-image').classList.contains('is-child-open')) {
        e.stopPropagation();
        this.closest('.js-p-accordion-with-image').classList.remove('is-child-open');
        let targets = offTriggerCourseName[i].nextElementSibling;
        targets.classList.remove('is-dropdown-open');
        targets.style.height = '0';
      }
    });
  }
}
benefitAccordion();

function resizeElement() {
  const benefitTarget = document.getElementsByClassName('js-benefit-target');
  for (let i = 0; i < benefitTarget.length; i++) {
    let elementSetHeight = benefitTarget[i].firstElementChild;
    elementSetHeight.offsetHeight;
    const heightPx = elementSetHeight.offsetHeight;
    if (benefitTarget[i].classList.contains('is-dropdown-open')) {
      benefitTarget[i].style.height = heightPx + 'px';
    }
  }
}
resizeElement();

let resizeFlg;
function windowResizeFunc() {
  //待ち時間中リセット
  if (resizeFlg !== false) {
    clearTimeout(resizeFlg);
  }
  //100ms待機後リサイズ処理
  resizeFlg = setTimeout(function () {
    resizeElement(); //リサイズ処理
  }, 100);
}
window.addEventListener('resize', windowResizeFunc);


//Swiper Carousel
const thumbClass = 'thumbnails__item';
const mytap = window.ontouchstart === null ? 'touchstart' : 'click';

const renderThumbnails = (swiper, current, total) => {
  return Array.from(swiper.slides)
    .map((slide, i) => {
      const imgElement = slide.querySelector('img');
      const isActive = current === i + 1 ? 'current' : '';
      return `
         <div class="${thumbClass} ${isActive}" data-slideto="${i}" tabindex="0">
           ${imgElement ? imgElement.outerHTML : ''}
         </div>
       `;
    })
    .join('');
};

const initializeThumbnailClick = (swiper, thumbContainer) => {
  const thumbItems = thumbContainer.querySelectorAll(`.${thumbClass}`);
  thumbItems.forEach(thumbItem => {
    thumbItem.addEventListener('click', () => {
      const index = thumbItem.dataset.slideto;
      swiper.slideTo(index, 500, true);
    });
    thumbItem.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const index = thumbItem.dataset.slideto;
        swiper.slideTo(index, 500, true);
      }
    });
  });
};

const initializeSwiper = (swiperElement, thumbnailElement) => {
  const swiper = new Swiper(swiperElement, {
    autoHeight: true,
    pagination: {
      el: thumbnailElement,
      type: 'custom',
      renderCustom: (swiper, current, total) => {
        return renderThumbnails(swiper, current, total);
      }
    }
  });
  const thumbContainer = document.querySelector(thumbnailElement);
  initializeThumbnailClick(swiper, thumbContainer);
  swiper.on('slideChange', () => initializeThumbnailClick(swiper, thumbContainer));
};

initializeSwiper('#slider_01', '.thumbnails.thumbnails_01');
initializeSwiper('#slider_02', '.thumbnails.thumbnails_02');
